module.exports = __webpack_public_path__ + "img/ICONO15.e5b2a099.png";